import { alpha, keyframes } from '@mui/material';
import { CRM_PALETTE as P } from '../../theme/brandPalette';

/** La paleta de la sección En vivo: el dorado del CRM como único acento, verde solo para "en vivo". */
export const ORO = P.brand.golden;
export const VERDE = '#22c55e';
export const PAPEL = '#141414';
export const PAPEL_2 = '#1a1a1a';
export const COLOR_ESTADO = {
  live:      { label: 'EN VIVO', color: VERDE },
  por_empezar: { label: 'POR EMPEZAR', color: ORO },
  scheduled: { label: 'AGENDADA', color: '#60a5fa' },
  ended:     { label: 'TERMINÓ', color: '#94a3b8' },
  cancelled: { label: 'CANCELADA', color: '#94a3b8' },
} as const;

/** El punto que late del "en vivo"; se queda quieto si el sistema pide menos movimiento. */
export const latido = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 ${alpha(VERDE, 0.55)}; }
  70% { box-shadow: 0 0 0 9px ${alpha(VERDE, 0)}; }
`;

export const botonPrimario = (color = ORO) => ({
  minHeight: 44, px: 2.5, fontWeight: 800, letterSpacing: 0.2, borderRadius: 2,
  bgcolor: color, color: '#111', boxShadow: `0 6px 20px ${alpha(color, 0.25)}`,
  transition: 'background-color .2s, box-shadow .2s, transform .2s',
  '&:hover': { bgcolor: alpha(color, 0.88), boxShadow: `0 8px 26px ${alpha(color, 0.35)}` },
  '&.Mui-disabled': { bgcolor: alpha(color, 0.18), color: alpha('#fff', 0.35), boxShadow: 'none' },
  '&:focus-visible': { outline: `2px solid ${alpha('#fff', 0.8)}`, outlineOffset: 2 },
});

export const botonSecundario = {
  minHeight: 44, px: 2, fontWeight: 700, borderRadius: 2, borderColor: alpha(ORO, 0.4), color: ORO,
  transition: 'background-color .2s, border-color .2s',
  '&:hover': { borderColor: ORO, bgcolor: alpha(ORO, 0.06) },
  '&:focus-visible': { outline: `2px solid ${alpha('#fff', 0.8)}`, outlineOffset: 2 },
};

export const tarjeta = (acento = ORO, destacada = false) => ({
  position: 'relative' as const, overflow: 'hidden' as const, borderRadius: 2.5,
  background: destacada ? `linear-gradient(135deg, ${alpha(acento, 0.16)} 0%, ${PAPEL_2} 55%, ${PAPEL} 100%)` : PAPEL,
  border: `1px solid ${alpha(acento, destacada ? 0.45 : 0.18)}`,
  transition: 'border-color .2s, box-shadow .2s',
  '&:hover': { borderColor: alpha(acento, 0.6), boxShadow: `0 10px 30px ${alpha('#000', 0.35)}` },
});

export const rotulo = { fontSize: 11, fontWeight: 800, letterSpacing: 0.8, textTransform: 'uppercase' as const, color: alpha('#fff', 0.55) };
